export const orgChurnIndicatorsByOrgIdsQuery = `
query OrgChurnIndicatorsByOrgIds($first: Int!, $where: Org_churn_indicatorWhereInput, $order: [Org_churn_indicatorOrder!]) {
  org_churn_indicators(first: $first, where: $where, order: $order) {
    edges {
      node {
        objectId
        status
        churn_risk
        eligible
        eligibility_reason
        last_login_at
        last_activity_created_at
        last_activity_class
        days_since_last_login
        days_since_last_activity_creation
        login_inactive
        creation_inactive
        config_source
        login_inactivity_days
        creation_inactivity_days
        computed_at
        updatedAt
        org_pointer {
          objectId
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export const churnRiskOrgIdsQuery = `
query ChurnRiskOrgIds($first: Int!, $where: Org_churn_indicatorWhereInput) {
  org_churn_indicators(first: $first, where: $where, order: [updatedAt_DESC]) {
    count
    edges {
      node {
        objectId
        org_pointer {
          objectId
        }
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");
